import { useContext } from "react";
import { QuestionsPageContext } from "../../../context/QuestionsPageContext";

export default function OrderBy() {
  const { order, setPeriod } = useContext(QuestionsPageContext);
  function handlePeriodClick(e) {
    const element = e.currentTarget;
    document.querySelectorAll("[data-period]").forEach((el) => {
      el.classList.remove("selected-period");
    });
    element.classList.add("selected-period");
    setPeriod(element.dataset.period);
    console.log(element.dataset.period);
  }
  return (
    <>
      {order === "answers_count" && (
        <ul className="txt-center d-flex text-size-90">
          <li className="selected-period" onClick={handlePeriodClick} data-period="today">
            today
          </li>
          <li onClick={handlePeriodClick} data-period="week">
            this week
          </li>
          <li onClick={handlePeriodClick} data-period="month">
            this month
          </li>
          <li onClick={handlePeriodClick} data-period="year">
            this year
          </li>
        </ul>
      )}
    </>
  );
}
